/**
 * AssessmentReport.js
 *
 * Thin wrapper that renders AssessmentCanvasV2 (Mantine-based modern canvas).
 * The legacy MUI-based report view has been removed as AssessmentCanvasV2
 * provides all the same features with better UX.
 *
 * This wrapper exists to maintain route compatibility with /assessment-report/:modelId
 */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import AssessmentCanvasV2 from './canvas/AssessmentCanvasV2.jsx';

const AssessmentReport = ({ modelId: propModelId, assessmentUuid: propAssessmentUuid }) => {
  // Get modelId from props (when used inline) or URL params (when used as route)
  const { modelId: paramModelId } = useParams();
  const location = useLocation();
  const modelId = propModelId || paramModelId;

  // Get assessmentUuid from router state (passed from navigation)
  const routerStateAssessmentUuid = location.state?.assessmentUuid;
  const routerStateAssessmentName = location.state?.assessmentName;

  // RTK-first: Get assessmentUuid from RTK assessments slice by finding assessment linked to this model
  const assessmentsById = useSelector((state) => state.assessments?.byId || {});
  const rtkAssessmentUuid = useMemo(() => {
    // Find assessment that belongs to this model
    const assessment = Object.values(assessmentsById).find(a => a.model_uuid === modelId);
    return assessment?.info?.assessment_uuid || assessment?.assessment_uuid;
  }, [assessmentsById, modelId]);

  // Get assessmentUuid: props first, then router state, then RTK slice
  const assessmentUuid = propAssessmentUuid || routerStateAssessmentUuid || rtkAssessmentUuid;

  return (
    <AssessmentCanvasV2
      modelId={modelId}
      assessmentUuid={assessmentUuid}
      assessmentName={routerStateAssessmentName}
    />
  );
};

export default AssessmentReport;
